export default "__VITE_ASSET__oYglfi6d__"